import { ArrowRightIcon, MenuIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
export default function Navbar() {
  const [isOpen, setisOpen] = useState(false);
  function handleClick() {
    setisOpen(!isOpen);
  }
  return (
    <header className="  top-0 z-10 ">
      <div className="container mx-auto flex md:flex-wrap p-5 md:items-center justify-between">
        <div className="flex-shrink-0">
          <a className="title-font font-medium text-white mb-4 md:mb-0">
            <a href="#about" className="ml-3 text-xl ">
              Ritesh kumar
            </a>
          </a>
        </div>
        <nav className="hidden  md:block mr-auto ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
          <a href="#education" className="mr-5 hover:text-white">
            Education
          </a>
          <a href="#projects" className="mr-5 hover:text-white">
            Projects
          </a>{" "}
          <a href="#skills" className="mr-5 hover:text-white">
            Skills
          </a>{" "}
          <a href="#awards" className="mr-5 hover:text-white">
            Awards
          </a>{" "}
        </nav>
        <div className="justify-end">
          <button
            type="button"
            className="mr-5 justify-end md:hidden"
            onClick={handleClick}
          >
            <svg
              className="h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              {isOpen && (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                />
              )}
              {!isOpen && (
                <path
                  fillRule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                />
              )}
            </svg>
          </button>
        </div>
      </div>
      <div className=" md:hidden">
        <nav
          className={`lg:flex ${
            isOpen ? "block" : "hidden"
          } divide-y divide-yellow-500  top-16 left-0  z-40 flex flex-col  font-semibold w-full shadow-md  p-6 pt-2 `}
        >
          <a href="#projects" className="mr-5   my-2 hover:text-white ">
            Past Work
          </a>
          <a href="#skills" className="mr-5 hover:text-white">
            Skills
          </a>
        </nav>
      </div>
    </header>
  );
}

// import { ArrowRightIcon, MenuIcon } from "@heroicons/react/solid";
// import React, { useState } from "react";
// export default function Navbar() {
//   const [menu, setMenu] = useState([{ text: "" }, { val: false }]);

//   return (
//     <header className="bg-gray-800 md:sticky top-0 z-10">
//       <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
//         <a className="title-font font-medium text-white mb-4 md:mb-0">
//           <a href="#about" className="ml-3 text-xl">
//             Ritesh kumar
//           </a>
//         </a>
//         <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
//           <a href="#projects" className="mr-5 hover:text-white">
//             Past Work
//           </a>
//           <a href="#skills" className="mr-5 hover:text-white">
//             Skills
//           </a>
//         </nav>
//         <a
//           href="#contact"
//           className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0"
//         >
//           Hire Me
//           <ArrowRightIcon className="w-4 h-4 ml-1" />
//         </a>
//       </div>
//       <div class="flex flex-wrap flex-col justify-between items-center md:space-x-4 bg-white py-6 px-6 relative">
//         <MenuIcon
//           onClick={() => {
//             setMenu();
//           }}
//           className="inline-block md:hidden w-8 h-8 bg-gray-200 text-gray-600 p-1"
//         ></MenuIcon>
//         <nav
//           class={`${menu}absolute md:relative top-16 left-0 md:top-0 z-20 flex flex-col md:flex-row md:space-x-6 font-semibold w-full md:w-auto bg-white shadow-md rounded-lg md:rounded-none md:shadow-none md:bg-transparent p-6 pt-0 md:p-0`}
//         >
//           <a href="#" class="text-indigo-600 hover:underline">
//             Home
//           </a>
//           <a href="#" class="text-gray-600 hover:underline">
//             About us
//           </a>
//           <a href="#" class="text-gray-600 hover:underline">
//             Services
//           </a>
//           <a href="#" class="text-gray-600 hover:underline">
//             Blog
//           </a>
//           <a href="#" class="text-gray-600 hover:underline">
//             Contact
//           </a>
//         </nav>
//       </div>
//     </header>
//   );
// }
